import { ReactElement } from 'react';
import { MonthInput } from '../MonthInput';
import { months } from './constants';
import { useTranslation } from 'react-i18next';
import { FormContainer } from './styles';
import { useFormContext } from 'react-hook-form';

interface FormContentProps {
  loading: boolean;
  year: string;
}

export function FormContent({
  loading,
  year,
}: Readonly<FormContentProps>): ReactElement {
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const currentYear = new Date().getFullYear().toString();

  return (
    <FormContainer>
      {months.map((month) => (
        <MonthInput
          name={`${year}.${month}.value`}
          label={t(`mesesDoAno.${month}`)}
          updatedAt={getValues(`${year}.${month}.updatedAt`)}
          key={`${year}.${month}-input`}
          disabled={loading}
          isPast={year <= currentYear && !!getValues(`${year}.${month}.past`)}
          onChange={() => {
            if (getValues(`${year}.${month}.past`)) {
              setValue(`${year}.${month}.past`, '');
            }
          }}
        />
      ))}
    </FormContainer>
  );
}
